import FieldSet, { Legend } from '@nokia-csf-uxr/ccfk/FieldSet';
import React from 'react';
import { CONFIG } from '../../../config';
import { AccountContext } from '../../../contexts/AccountContext';
import { SingleBandLinkReferenceContext, SingleBandLinkUserContext } from '../../../contexts/SingleBandLinkContext';
import Dropbox from '../../Dropbox';
import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/esm/Row';
import Form from 'react-bootstrap/esm/Form';
import Col from 'react-bootstrap/esm/Col';
import EquipmentDetails from './EquipmentDetails';
import WLDInputComponent from '../WLDInputComponent';
import { DualBandLinkReferenceContext, DualBandLinkUserContext } from '../../../contexts/DualBandLinkContext';
import { DualBandLinkForm } from '../LinkForm';

/**
 * Equipment type component
 */
export default class EquipmentType extends WLDInputComponent {

    constructor(props: {band: number, bandItem: string}) {
        super(props);
    }

    /**
     * Function is called when the equipment type is changed
     * @param token user's token
     * @param link  user's data
     * @param newData New data which has been selected
     * @param referenceData in dualband, it's necessary field to refresh the equipment type
     */
    onChange(token: string, link: Readonly<any>, newData: { idEquip: number, frequences: any}, referenceData: any) {

        let equipTypeKeyVal = super.getKeyValue("equipType")

        if(newData.idEquip == link[equipTypeKeyVal]?.idEquip) { // If the link is edited, we don't reload the equipment details (when you create a new link, the default link is edited some milliseconds to display default conf)
           return;
        }

        let comp = this

        let equipFreqKeyVal = super.getKeyValue("equipFreq")

        link.define(equipTypeKeyVal, newData, function() {
            if(comp.props.band == 2) { // if the user is in dual band
                DualBandLinkForm.updatedEquipments(token, referenceData, link, newData, comp.props.bandItem, comp.props.bandItem == "" ? "2" : "");
            }

            if(link[equipTypeKeyVal].frequences == null) {
                link.define(equipFreqKeyVal, null);
                return;
            }
            
            let foundFrequency = false;
            newData?.frequences?.forEach((freq:any) => {
                if(freq.idFreq == link[equipFreqKeyVal]?.idFreq) {
                    foundFrequency = true;
                    return;
                }
            });

            if(!foundFrequency) {
                link.define(equipFreqKeyVal, link.equipType.frequences[0]);
            } else {
                EquipmentDetails.refreshModulations(token, link, comp.props.bandItem);
            }

            if(comp.props.band == 2) {
                EquipmentDetails.refreshDualbandAntennas(token, link, "", "1");
            }
        })
    }

    render() {
        return (
            <Col>
                <Form.Label>Equipment</Form.Label>
                <AccountContext.Consumer>
                    {(account) => (
                    <>
                    {this.props.band == 1 ?
                        <SingleBandLinkUserContext.Consumer>
                        {(link) => (
                            <SingleBandLinkReferenceContext.Consumer>
                                {(linkRef) => (
                                    <Dropbox 
                                        uniqueKey="idEquip"
                                        displayInputKey="type"
                                        showStartedKey={link?.edit}
                                        startedKey={link[super.getKeyValue("equipType")]?.idEquip}
                                        values={(linkRef.equipNorms != null && link?.equipNorms?.index != null) ? linkRef.equipNorms[link.equipNorms.index].equipments : []} 
                                        onChange={(newData) => this.onChange(account.token, link, newData, linkRef)}
                                    />
                                )}
                            </SingleBandLinkReferenceContext.Consumer>
                        )}
                        </SingleBandLinkUserContext.Consumer>
                    :
                        <DualBandLinkUserContext.Consumer>
                            {(link) => (
                                <DualBandLinkReferenceContext.Consumer>
                            {(linkRef) => (
                                <>
                                <Dropbox 
                                    uniqueKey="idEquip"
                                    displayInputKey="type"
                                    showStartedKey={link?.edit}
                                    startedKey={link[super.getKeyValue("equipType")]?.idEquip}
                                    values={(linkRef.equipNorms != null && link?.equipNorms?.index != null) ? linkRef.equipNorms[link.equipNorms.index]
                                        [linkRef.equipNorms[link.equipNorms.index][super.getKeyValue("equipments")] == null ? "equipments" : super.getKeyValue("equipments")] 
                                        : []
                                    } 
                                    onChange={(newData) => this.onChange(account.token, link, newData, linkRef)}
                                />
                                </>
                            )}
                            </DualBandLinkReferenceContext.Consumer>
                            )}
                        </DualBandLinkUserContext.Consumer>
                    }
                    </>
                    )}
                </AccountContext.Consumer>
            </Col>
        );
    }

}